<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G7rhG7/images/TrueTalesGhostlyEnctrs.jpg?1731429793747" alt="This image is the cover for the book True Tales of Ghostly Encounters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">True Tales of Ghostly Encounters
      </h1>
      <p class="bookDescription body article font2">
        <p><i>FATE</i> magazine has published thousands of ghost stories, true experiences of ordinary people who have had extraordinary encounters with the hereafter. Compiled and edited by Andrew Honigman, this collection features the best of these chilling, bizarre, and heartwarming tales. These detailed accounts of messages, gifts, blessings, and assistance from the spirit world provide remarkable proof of life after death.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Honigman
      </h2>
      
      <p class="authorDescription body article"><P><B>Andrew Honigman (Minnesota)</B> is a member <I>FATE </I>magazine's editorial staff. He has had editorial responsibility for the reader contribution departments of the magazine and he reads and evaluates submissions, communicates with contributors, and edits sections of the magazine. He has a long-time interest in comparative religion, philosophy, and mythology.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78fe914e